import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
// import { disableBodyScrolling } from '@/utils/disableBodyScrolling';

@Component
export class MobileFiltersTrigger extends ThemeComponent {
    @Prop({default: window.pageYOffset}) scrollPosition!: number;

    init() {
        // Give initial value for scrollPosition
        this.scrollPosition = window.pageYOffset;

        // Init click event listeners
        this.initClickEventListener();

        // Init navigation breakpoint check
        this.matchMedia();
    }

    initClickEventListener() {
        this.$listen(this, 'click', (evt) => {

            const textElement = (evt.currentTarget as HTMLElement);
            const text = textElement.querySelector('.button-text') as HTMLElement;

            // Determine whether we are opening are closing
            const closing = document.body.classList.contains('mobile-filters-active');

            // Check mobile menu exists
            const mobileMenu = document.querySelector('.mobile-filters');

            if (!mobileMenu) {
                return;
            }

            // Are we closing?
            if (closing) {

                // this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);

            // No, we're opening
            } else {

                // Disable body scrolling
                // this.scrollPosition = disableBodyScrolling(true, this.scrollPosition);
            }

            // Body class
            document.body.classList.toggle('mobile-filters-active');

            // Mobile menu class
            mobileMenu.classList.toggle('mobile-filters--active');

            // Trigger class
            this.classList.toggle('navigation-mobile-filters-toggle--active');
        });
    }

    matchMedia() {
        // Remove mobile menu active active if greater than $navigation-breakpoint
        const mmBreakpoint = window.matchMedia(`(max-width: 950px)`);

        // Check breakpoint, remove mobile menu classes if required
        const breakpointChecker = () => {
            if (!mmBreakpoint.matches) {

                // Only run if filters are active
                if (!document.body.classList.contains('mobile-filters-active')) {
                    return;
                }

                // Check mobile menu exists
                const mobileMenu = document.querySelector('.mobile-filters');
                if (!mobileMenu) {
                    return;
                }

                // Enable scrolling
                // this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);

                // Body class
                document.body.classList.remove('mobile-filters-active');

                // Mobile menu class
                mobileMenu.classList.remove('mobile-filters--active');

                // Trigger class
                this.classList.remove('navigation-mobile-filters-toggle--active');
            }
        };

        // Init listener and initial check
        breakpointChecker();
        mmBreakpoint.addListener(breakpointChecker);
    }
}
